/* Скрим и оболочка — модалка «Новая бронь» (prototype/Prototype.dc.html:1409-1410). */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 52;
  display: grid;
  place-items: center;
  padding: 28px;
  background: var(--scrim);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
}

.overlay[data-state='open'] {
  animation: 0.2s ease both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(scrim-in);
}

/*
 * `Content` рендерится внутри `Overlay` (а не рядом, сиблингом) — так же, как в самом макете
 * скрим `display:grid;place-items:center` содержит карточку модалки прямым ребёнком. Это даёт
 * центрирование без `translate(-50%,-50%)` и снимает вопрос порядка z-index между Overlay и
 * Content: вложенный элемент красится поверх фона родителя всегда, независимо от чисел.
 * На поведение Radix (клик вне, фокус-трап, Escape) вложенность не влияет — оба живут в одном
 * `Portal`, а определение «клик снаружи» у `DismissableLayer` смотрит на DOM-предков цели клика
 * относительно Content, а не на порядок сиблингов (node_modules/@radix-ui/react-dismissable-layer/
 * dist/index.mjs:219).
 */
.content {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 56px);
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 16px;
  box-shadow: var(--shadow-modal);
  overflow: hidden;
  outline: none;
}

/*
 * ⚠️ `.content { outline: none }` ВЫШЕ НЕДОСТАТОЧНО, и это проверено машиной, а не выведено.
 *
 * Панель фокусируема (`tabIndex: -1` ставит сам Radix) и получает фокус при открытии — иначе он
 * достался бы крестику «Закрыть», и первый же Enter стёр бы форму (см. `Dialog.tsx`). Значит на
 * неё наводится глобальное кольцо `:focus-visible { outline: 2px solid var(--accent) }` из
 * `shared/styles/reset.css` — а это 2px акцентная рамка вокруг ВСЕЙ модалки.
 *
 * У `.content` и у `:focus-visible` **одинаковая специфичность** (0,1,0), поэтому побеждает тот,
 * кто в собранном CSS стоит позже. ЗДЕСЬ это решает раскладка чанков: `Dialog` лежит в `ui-*.css`,
 * `reset.css` — в `index-*.css`, а в `dist/index.html` ui-чанк подключён ПЕРВЫМ из четырёх. То есть
 * reset перебивал модалку не по невезению, а всегда.
 *
 * Соседний `widgets/booking-modal` пишет ровно то же `outline: none` и выигрывает — но НЕ потому,
 * что «его чанк грузится позже»: это объяснение машинно неверно. Его `.layer`
 * попал в ТОТ ЖЕ `index-*.css`, что и reset, и просто оказался ниже по файлу: смещение 42619 против
 * 10444. Там лотерея порядка ПРАВИЛ, здесь — детерминированный проигрыш по порядку ЧАНКОВ. Симптом
 * один, причины разные; лечение общее — специфичность.
 *
 * Замерено зондом на живой сборке:
 *   карточка брони — outline-style: none  (её правило ниже reset в том же чанке)
 *   модалка        — outline: 2px solid oklch(0.54 0.15 45)  ← кольцо на всю панель
 *
 * Специфичность (0,2,0) снимает вопрос порядка совсем. Кольцо у настоящих элементов управления
 * ВНУТРИ модалки при этом остаётся — гасится только контейнер, который сам ничего не делает.
 */
.content:focus-visible {
  outline: none;
}

.content[data-state='open'] {
  animation: 0.26s var(--ease-out) both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(modal-in);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 19px 22px;
  border-bottom: 1px solid var(--line);
  flex-shrink: 0;
}

.headerText {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.iconTile {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: var(--accent-soft);
  color: var(--accent);
}

.titleGroup {
  min-width: 0;
}

.title {
  font-family: 'Fraunces Variable', serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.01em;
  line-height: 1;
}

.description {
  margin-top: 3px;
  font-size: 11.5px;
  color: var(--ink-3);
}

.close {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel);
  color: var(--ink-2);
  cursor: pointer;
}
/*
 * ⚠️ `var(--on-accent)`, а НЕ литеральный `#fff` из макета (docs/reference/phase-2-mockup.md:120).
 *
 * Крестик красится `currentColor` (`shared/ui/icon`), подписи у кнопки нет — то есть иконка ЕСТЬ
 * эта кнопка, и порог у неё не-текстовый: 3 : 1 (WCAG 1.4.11). Замерено `tools/contrast.mjs`
 * (пара «крестик «Закрыть» под курсором»):
 *
 *     #fff          светлая 5.13 ✓   тёмная 2.87 ✗   ← в тёмной теме --st-cancel СВЕТЛЕЕТ до
 *     --on-accent   светлая 4.95 ✓   тёмная 6.33 ✓      oklch(70%), и белый крестик на нём тонет
 *
 * Литерал пролежал здесь с задачи 5 и все девять задач был НЕВИДИМ для гейта: цвет мимо палитры
 * нельзя выразить в таблице `PAIRS` — она меряет токены. Молчал он ещё и потому, что до задачи 14
 * у `Dialog` не было ни одного потребителя: пиксель не рисовался никогда. Теперь литералы в
 * CSS-модулях ищет машина (`tools/contrast.mjs`, раздел «ЛИТЕРАЛЬНЫЕ ЦВЕТА В КОМПОНЕНТАХ»).
 *
 * Размен ровно тот, что проект уже сделал для инициалов аватаров и галки системного события и
 * пометил «обратно НЕ откатывается» (docs/HANDOFF.md, docs/reference/contrast-audit.md): в светлой
 * теме `--on-accent` ≈ белый (oklch 99%) — вид макета сохранён, в тёмной он тёмный — и крестик
 * читается. В покое пара своё берёт и без правки: `--ink-2` на `--panel` = 9.10 / 9.04.
 */
.close:hover {
  background: var(--st-cancel);
  color: var(--on-accent);
  border-color: transparent;
}

/*
 * Тело — не владение Dialog: в «Новой брони» это скролл-зона с паддингом 22px и подвалом кнопок
 * (prototype/Prototype.dc.html:1420, 1477), а у модалки MAX подвала нет вообще. `flex/min-height:0`
 * здесь — не косметика, а необходимость: без них вложенный `flex:1;overflow-y:auto`, который
 * потребитель повесит на свой контейнер, не получит ограниченную высоту и не будет скроллиться.
 */
.body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
